type ArrowProps = {
	className?: string;
	color?: string;
	rotation?: number; // degrees
};

export default function Arrow({ className = "", color = "currentColor", rotation = 0 }: ArrowProps) {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 23 23"
			fill="none"
			style={{
				transform: `rotate(${rotation}deg)`,
				transition: "transform 0.3s ease-in-out",
			}}
		>
			<path
				d="M12.1377 22.1278C11.7699 22.4957 11.1729 22.4957 10.805 22.1278C10.4374 21.7599 10.4379 21.1636 10.8057 20.7958L16.3977 15.2038C16.5509 15.0506 16.6923 14.89 16.8219 14.7232C17.647 13.6617 16.6117 12.3976 15.2673 12.3977L5.77513 12.3982C5.25498 12.3982 4.83342 11.9764 4.83323 11.4563C4.83323 10.9361 5.25486 10.5144 5.77513 10.5144L15.0693 10.5139C16.4625 10.5138 17.4894 9.16286 16.5457 8.13794C16.4977 8.08574 16.4483 8.03429 16.3977 7.98365L11.209 2.795C10.8415 2.42714 10.8419 1.83068 11.2097 1.46297C11.5775 1.09547 12.174 1.09594 12.5417 1.46366L22.1726 11.0945C22.4368 11.3587 22.4368 11.7873 22.1726 12.0516C22.1337 12.0905 22.1004 12.1346 22.0683 12.1793C22.0401 12.2188 22.0085 12.2571 21.9731 12.2926L12.1377 22.1278Z"
				fill={color}
			/>
			<rect width="1.88403" height="15.2553" transform="matrix(-0.70711 -0.707104 0.70711 -0.707104 11.4688 22.7969)" fill={color} />
			<rect width="1.88403" height="15.1816" transform="matrix(0.70711 -0.707103 0.70711 0.707104 10.5469 2.13281)" fill={color} />
			<rect x="19.7656" y="10.5234" width="1.88403" height="16.4012" transform="rotate(90 19.7656 10.5234)" fill={color} />
		</svg>
	);
}
